import createSvgIcon from "./utils/create_icon"

const CircleOutline = createSvgIcon(<path clipRule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z" fill="currentColor" fillRule="evenodd" />, "CircleOutline")
export default CircleOutline
